export default __webpack_public_path__ + "static/media/group-2.7f222df1.svg";